export const videoTableHeading = [
  {
    text:'S.no',
    dataField: "sNo",
  },
  {
    text:'Title',
    dataField:'title'
  }
]